import { render, staticRenderFns } from "./HpHGrafica.vue?vue&type=template&id=b66585b6&scoped=true&"
import script from "./HpHGrafica.vue?vue&type=script&lang=js&"
export * from "./HpHGrafica.vue?vue&type=script&lang=js&"
import style0 from "./HpHGrafica.vue?vue&type=style&index=0&id=b66585b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66585b6",
  null
  
)

export default component.exports